import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { setPluginVersionList } from 'Workspace/Plugins/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { pluginId } = action;
  const workspacePluginVersionList = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_PLUGIN_VERSION_LIST,
    pluginId,
  });
  if (workspacePluginVersionList.type === constants.RTM_WORKSPACE_PLUGIN_VERSION_LIST_OK) {
    const versions = workspacePluginVersionList.response.versions;
    yield put(setPluginVersionList(pluginId, versions));

    if (typeof versions === 'undefined' || versions.length <= 0) {
      yield put(push(`/plugins/${pluginId}`));
    }
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.defaultError} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_PLUGIN_VERSION_LIST, catchErrors, sendRequest, connection);
}

